const getAppRelease = () => {
  const release = process.env?.NX_PUBLIC_RELEASE;
  return release && release.includes('.') ? release.split('.')[0] : 'development';
};

export {
  getAppRelease,
};
